import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rIstatistikPopup, rValue } from '../../models/.catalog';

export default class UstBilgiIstatistikDetayApi extends ApiBase<pList, rValue<rIstatistikPopup>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/UstBilgiIstatistikDetay',
      }),
      options
    );
  }
}
